import {
  type RoleRequirementsEvent,
  UnifiedAnalyticsEvent,
  type UnifiedPayload,
} from '../types';

import { spreadableTestingId } from './experiments';

interface UnifiedVerifyBoostContinuePayload
  extends UnifiedPayload<UnifiedAnalyticsEvent.VerifyBoostContinue> {
  roleReqQuestionnaireId: string;
  isVerifiedBoost: boolean;
}

const sendVerifyBoostContinueEvent =
  (onEvent: (event: RoleRequirementsEvent) => void) =>
  (questionnaireId: string, isVerifiedBoost: boolean): void => {
    const analyticsPayload = {
      eventName: UnifiedAnalyticsEvent.VerifyBoostContinue as const,
      isVerifiedBoost,
      currentPageSection: 'role requirements' as const,
      roleReqQuestionnaireId: questionnaireId,
      ...spreadableTestingId(),
    } as UnifiedVerifyBoostContinuePayload;

    onEvent({
      data: [
        {
          payload: {
            analytics: analyticsPayload,
          },
        },
      ],
    });
  };

export { type UnifiedVerifyBoostContinuePayload, sendVerifyBoostContinueEvent };
